import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';

@Component({
    selector: 'tran-icon-button',
    templateUrl: './icon-button.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class IconButtonComponent {
    public readonly icon = input<string>('');
    public readonly btnLevel = input<'ghost' | 'primary' | 'secondary' | 'tertiary'>('tertiary');
    public readonly btnType = input<'default' | 'warning' | 'danger'>('default');
    public readonly color = input<string>('');
    public readonly hoverColor = input<string>('');
    public readonly clicked = output<void>();
    public readonly title = input<string>('');
    public readonly ariaLabel = input<string>('');

    protected readonly iconClass = computed(() => `element-${this.icon()}`);
    protected readonly btnClass = computed(() => {
        const btn = 'btn';
        const level = this.btnLevel();
        const type = this.btnType();

        if (level === 'ghost') {
            return `${btn}-${level}`;
        }

        return `${btn}${level ? `-${level}` : ''}${type !== 'default' ? `-${type}` : ''}`;
    });
    protected readonly hoverClass = computed(() => (this.hoverColor() ? `hover:!text-${this.hoverColor()}` : ''));
    protected readonly colorClass = computed(() => (this.color() ? `!text-${this.color()}` : ''));
}
